module.exports = __webpack_public_path__ + "img/no-Doc.ef5e0534.svg";